module.exports = __webpack_public_path__ + "img/q.2baf18a5.jpg";